import { useState } from 'react';
import { Navigate } from 'react-router-dom-v5-compat';

import { PAGE_HEIGHT_WITHOUT_NAV_AND_SUBNAVS } from '~/common/constants/page';
import { ErrorPage } from '~/eds/src/components/ErrorPage/ErrorPage';
import { Layout } from '~/eds/src/components/Layout/Layout';
import { PanelProvider } from '~/eds/src/components/Panel/PanelContext';
import { TicketDetailsHeader } from '~/features/workflows-clm-evolution/tickets/tickets-details/TicketDetailsHeader';
import { TicketDetailsMain } from '~/features/workflows-clm-evolution/tickets/tickets-details/TicketDetailsMain';
import { TicketDetailsSidebar } from '~/features/workflows-clm-evolution/tickets/tickets-details/TicketDetailsSidebar';
import { api } from '~/redux/api/createApi';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const WorkflowCLMEvolutionTicketsTicketDetailPage = () => {
  const { params, location } = useRouting();
  const { ticketId } = params;
  const { data, isLoading, error } = api.endpoints.getTicketK2.useQuery({
    ticketId: ticketId!,
  });
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(true);

  if (error) {
    return <ErrorPage preset="page-not-found" />;
  }

  const ticketDetailPath =
    RoutePathType.WorkflowCLMEvolutionTicketsDetail.replace(
      ':ticketId',
      ticketId ?? '',
    );
  if (ticketId && location.pathname === ticketDetailPath) {
    return <Navigate to={`${ticketDetailPath}/tasks`} replace />;
  }

  return (
    <Layout
      direction="column"
      minH={PAGE_HEIGHT_WITHOUT_NAV_AND_SUBNAVS}
      mx={-8}
      mb={-8}
    >
      <TicketDetailsHeader
        isLoading={isLoading}
        ticketName={data?.name ?? ''}
        ticketId={ticketId!}
        sidebar={{
          isExpanded: isSidebarExpanded,
          onToggleSidebar: () =>
            setIsSidebarExpanded(
              (prevIsSidebarExpanded) => !prevIsSidebarExpanded,
            ),
        }}
      />
      <Layout direction="row" h="100%" w="100%" flex={1}>
        <TicketDetailsSidebar isExpanded={isSidebarExpanded} />

        <PanelProvider>
          <TicketDetailsMain />
        </PanelProvider>
      </Layout>
    </Layout>
  );
};

export default WorkflowCLMEvolutionTicketsTicketDetailPage;
